import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { useAuth } from "../context/auth";

export function Navigation() {
  const { user, signOut } = useAuth();
  const [_scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="site-header">
      <nav className="page-wrap py-3.5 px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-baseline gap-2">
            <Link
              to="/"
              className="no-is-active text-[--ink] text-base font-display font-semibold tracking-tight"
            >
              Open Money
            </Link>
            <span className="text-[0.625rem] font-mono text-[--ink-muted] uppercase tracking-wide opacity-60">
              Beta
            </span>
          </div>

          {user && (
            <div className="flex items-center gap-6">
              <Link
                to="/bank_accounts"
                className="nav-link"
                activeProps={{ className: "nav-link is-active" }}
              >
                Accounts
              </Link>
              <Link
                to="/plaid_accounts"
                className="nav-link"
                activeProps={{ className: "nav-link is-active" }}
              >
                Banks
              </Link>
              <Link
                to="/home"
                className="nav-link"
                activeProps={{ className: "nav-link is-active" }}
              >
                Home
              </Link>
              <Link
                to="/transactions"
                className="nav-link"
                activeProps={{ className: "nav-link is-active" }}
                activeOptions={{ exact: false }}
              >
                Transactions
              </Link>
              <div className="w-px h-4 bg-[--line]" />
              <div className="flex items-center gap-3">
                <span className="text-[0.8125rem] text-[--ink-muted]">{user.email}</span>
                <button
                  type="button"
                  onClick={() => signOut()}
                  className="py-1.5 px-3 text-[0.8125rem]"
                >
                  Sign Out
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}
